import FDataTableMDP, { ActionType } from "@/components/table/FDataTableMDP";
import FCellPhoneMDP from "@/components/table/cell/FCellPhoneMDP";
import FCellStatusMDP from "@/components/table/cell/FCellStatusMDP";
import FCellDateTimeMDP from "@/components/table/cell/FCellDateTimeMDP";
import FCellCopyMDP from "@/components/table/cell/FCellCopyMDP";
import FCellLinksMDP from "@/components/table/cell/FCellLinksMDP";
import FCellBtnMDP from "@/components/table/cell/FCellBtnMDP";
import FCellBooleanMDP from "@/components/table/cell/FCellBooleanMDP";
import * as Action from "@/../src-gen/action";
import FSnackbar from "@/fsnackbar";
import Helper from "@/util/Helper";

export default class FPPSalesDashboardLeadFDataTableMDP extends FDataTableMDP {
  parent: any;
  constructor(props: { parent: any }) {
    super({
      myRefName: "fppSalesDashboardLeadFDataTableRef",
      enableSearch: true,
      title: "Lead File Status",
      itemKey: "mobile",
      enablePagination: true,
      enableExport: true,
      enableShowHideColumns: true,
      showFiltersByDefault: false,
    });
    
    this.parent = props.parent;

    this.addColumn({
      label: "Client Name",
      dataSelectorKey: "clientFullName",
      sortable: true,
    })
      .addColumn({
        label: "Mobile",
        dataSelectorKey: "mobile",
        columnCellMDP: new FCellPhoneMDP(),
        sortable: true,
        enableCopy: true,
        copyTooltipText: "Click to copy mobile number",
      })
      .addCurrencyColumn({
        label: "Debt Load",
        dataSelectorKey: "DebtLoad",
        align: "right",
      })
    
      .addColumn({
        label: "Attribution Code",
        dataSelectorKey: "attributionCode",
        columnCellMDP: new FCellBtnMDP({
          onClick: (item: any) => this.handleGenerateAttributionCode(item),
          color: "primary",
        }),
        sortable: false,
      })
      .addStatusColumn({
        label: "Lead Status",
        dataSelectorKey: "leadStatus",
        sortable: true,
        colorCodeData: this.getLeadStatusColorCode(),
        filterItemList: this.getLeadStatusFilterItems(),
        enableHeaderFilter: false,
      })
      .addDateTimeColumn({
        label: "Created",
        dataSelectorKey: "leadCreatedDate",
      })
      .addColumn({
        label: "Transferred",
        dataSelectorKey: "attributionMarked",
        columnCellMDP: new FCellBooleanMDP({
          outlined: true,
          successText: "Transferred",
          errorText: "Not Transferred",
          successColor: "#4CAF50",
          errorColor: "#FF9800",
        }),
        sortable: false,
        align: "center",
      })
        .addColumn({
        label: "Links",
        dataSelectorKey: "dsaCustomerOnboardingLink",
        columnCellMDP: new FCellLinksMDP({
          onClickCopy: (item: any) => this.handleCopyLink(item),
          onClickWhatsApp: (item: any) => this.handleSendWhatsAppLink(item),
          dataSelectorKeyToCopy: "dsaCustomerOnboardingLink",
          tooltipText: "Click to copy link",
        }),
        sortable: false,
        align: "center",
      })
      
      .addAction({
        type: ActionType.ADD,
        label: " New Client",
        onClick: () => this.handleAddClient(),
        noSelect: true,
      })
      .addAction({
        type: ActionType.REFRESH,
        label: "Refresh",
        onClick: () => this.handleRefresh(),
        noSelect: true,
      });
  }


  handleAddClient() {
    return new Promise((res) => {
      this.parent.showAddClientForm();
      res(true);
    });
  }

  handleRefresh() {
    return new Promise((res) => {
      this.parent.refreshLeadList();
      res(true);
    });
  }

  handleCopyLink(item: any) {
    if (!item || !item.mobile) {
      FSnackbar.error("Mobile number not available");
      return;
    }
    const existingLink =
      item.dsaCustomerOnboardingLink || item.onboardingLink || item.signupLink;
    if (existingLink) {
      Helper.copyToClipBoard(existingLink);
    } else {
      Action.Partner.SendDsaCustomerOnboardingLinkToCustomer.execute1(
        item.mobile,
        (output): void => {
          if (output) {
            item.dsaCustomerOnboardingLink = output;
            Helper.copyToClipBoard(output);
          } else {
            FSnackbar.error("Link not available");
          }
        },
        (error) => {
          FSnackbar.error("Error fetching link");
        }
      );
    }
  }

  handleSendWhatsAppLink(item: any) {
    if (!item || !item.mobile) {
      FSnackbar.error("Mobile number not available");
      return;
    }
    Action.Partner.SendDsaCustomerOnboardingLinkToCustomer.execute1(
      item.mobile,
      (output): void => {
        if (output) {
          item.dsaCustomerOnboardingLink = output;
          FSnackbar.success("WhatsApp link sent successfully");
        } else {
          FSnackbar.error("Link not available");
        }
      },
      (error) => {
        FSnackbar.error("Error sending link");
      }
    );
  }

  handleGenerateAttributionCode(item: any) {
    if (!item || !item.mobile) {
      FSnackbar.error("Mobile number not available");
      return;
    }
    Action.Partner.GenerateAttributionCode.execute1(
      item.mobile,
      (output): void => {
        if (output && output.attributionCode) {
          item.attributionCode = output.attributionCode;
          FSnackbar.success("Attribution code generated successfully");
        } else {
          FSnackbar.error("Failed to generate attribution code");
        }
      },
      (error) => {
        FSnackbar.error("Error generating attribution code");
      }
    );
  }

  getLeadStatusColorCode() {
    return {
      Lead: { color: "#16A34A", textColor: "white" },
      DCP_Eligible: { color: "#0F2854", textColor: "white" },
      DCP_Ineligible: { color: "#DC2626", textColor: "white" },
      DRP_Eligible: { color: "#0F2854", textColor: "white" },
      DRP_Ineligible: { color: "#DC2626", textColor: "white" },
      // Keep old values for backward compatibility
      Eligible: { color: "#0F2854", textColor: "white" },
      Ineligible: { color: "#DC2626", textColor: "white" },
      "DRP Eligible": { color: "#0F2854", textColor: "white" },
      "DCP Eligible": { color: "#0F2854", textColor: "white" },
    };
  }

  getLeadStatusFilterItems() {
    return [
      { id: "Lead", name: "Lead" },
      { id: "DCP_Eligible", name: "DCP_Eligible" },
      { id: "DCP_Ineligible", name: "DCP_Ineligible" },
      { id: "DRP_Eligible", name: "DRP_Eligible" },
      { id: "DRP_Ineligible", name: "DRP_Ineligible" },
    ];
  }

}

